module.exports = __webpack_public_path__ + "img/UG.3e232db6.svg";